import Vue from 'vue'
import Vuex from 'vuex'
import login from './modules/login'
import callsServices from './modules/callServices'
import dashboard from './modules/dashboard'
import predictiveModels from './modules/predictiveModels'
import notifications from './modules/notifications'
// import viewer from './modules/servicesGis/viewerGis'
// import optionGis from './modules/servicesGis/optionsGis'
// import actionsGis from './modules/servicesGis/actionsGis'
import dashAmbientalMeteo from './modules/dashboardAmbientalMeteo'
import dashboardParks from './modules/dashboardParks'
import dashboardEnvironment from './modules/dashboardEnvironment'
import dashboardParksAndGardens from './modules/dashboardParksAndGardens'
import dashboardVisualization from './modules/dashboardVisualization'
import dashboardMobility from './modules/dashboardMobility'
import dashboardCruise from './modules/dashboardCruise'
import dashboardCRM from './modules/dashboardCRM'
import globales from './globales'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    login,
    callsServices,
    dashboard,
    predictiveModels,
    notifications,
    /*
    viewer,
    optionGis,
    actionsGis,
    */
    dashAmbientalMeteo,
    dashboardParks,
    dashboardParksAndGardens,
    dashboardEnvironment,
    dashboardVisualization,
    dashboardMobility,
    dashboardCruise,
    dashboardCRM,
    globales
  }
})



// WEBPACK FOOTER //
// ./src/store/store.js